import { get, post, put, del } from "./methods"
import { GoodsList, GoodsItem } from "@/interface/goods"

export const getGoodsList = (params: any) => get<GoodsList>(`/api/mr/oldObjects/${params.pageNum}/${params.pageSize}`)
export const addGoods = (params: any) => post('/api/mr/material/oldObject', params)
export const star = (params: any) => put(`/api/mr/material/oldObject/${params.id}/${params.like}`)
export const getGoodsDetail = (params: any) => get<GoodsItem>(`/api/mr/oldObject/${params.id}`)
export const deleteGoods = (params: any) => del(`/api/mr/material/oldObject/${params.id}`)
export const editGoods = (params: any) => put(`/api/mr/material/oldObject`,params)
